import '../css/Tutorial.css'
export default function Tutorial({
    tutorialActive,
    setTutorialActive
}) {
    return(
        <dn-tutorial-cover>
            <dn-tutorial-message>
                <h2>Welcome to DoNotes</h2>
                <dn-flex>
                    
                <md-outlined-button onClick={(e)=>{setTutorialActive(false)}}>
                    Close Tutorial
                </md-outlined-button>
                
                <md-filled-tonal-button disabled>
                    Begin Tutorial
                </md-filled-tonal-button>
                </dn-flex>
            </dn-tutorial-message>
        </dn-tutorial-cover>
    )
}